module.exports = require("bottlejs");


//////////////////
// WEBPACK FOOTER
// external "bottlejs"
// module id = 37
// module chunks = 0